var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid justify-items-end w-5 mr-3",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("@/assets/images/home/menu.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }